import axios from "axios";
import firebase from "./firebase";

export const ivrService = async (phoneNumber, voiceContent) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_IVR}`,
    { phoneNumber, voiceContent },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};
